module.exports = __webpack_public_path__ + "static/media/aisha.0cb0c529.png";